import React, {ReactElement, useEffect, useRef} from 'react';
import {Icon} from '@iconify/react';
import {IElementChatbot} from '../../../incase-domain/elements/chatbot';
import Button from '../../../incase-domain/components/button/Button';

interface ChatbotElementComponentProps {
    element: IElementChatbot;
}

function ChatbotElementComponent({element}: ChatbotElementComponentProps): ReactElement {
    const containerRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (containerRef.current) {
            setTimeout(() => {
                containerRef.current?.scrollTo({top: containerRef.current.scrollHeight, behavior: 'smooth'});
            }, 100);
        }
    }, [element?.id]);

    const chatHistory = [
        'Hello! How can I assist you today?',
        'Hi, I haven’t been feeling well lately.',
        'I’m sorry to hear that. Can you tell me more about your symptoms?',
        'I’ve been feeling really tired, and I sometimes get short of breath even when I’m just walking a little.',
        'Thanks for sharing that. How long have you been experiencing these symptoms?',
        'It started about two weeks ago, I think. It’s been getting a bit worse each day.',
        'Got it. Have you noticed any other symptoms—like swelling in your legs, chest pain, or a cough?',
        'Actually, yes. My ankles have been a bit swollen and I’ve had a dry cough for a few days now.',
        'That’s important information. Do you have any history of heart or lung conditions? Or are you currently on any medications?',
        'No, I don’t have any history of those conditions, and I’m not on any medications. I’m generally healthy.',
    ];

    return (
        <div className="c-chatbot">
            <div className="c-chatbot__header">
                <Icon icon="solar:user-bold" className="c-chatbot__header_icon" />
                {element?.header}
            </div>

            <div className="c-chatbot__container" ref={containerRef}>
                {chatHistory?.map((msg, index) => (
                    <div
                        key={index}
                        className={`c-chatbot__container_message c-chatbot__container_message--${index % 2 === 0 ? 'user' : 'bot'}`}
                    >
                        {msg}
                    </div>
                ))}
            </div>

            <div className="c-chatbot__input">
                <input type="text" value="" placeholder="Send message..." />
                <Button variant="ghost" trailing="solar:map-arrow-right-bold-duotone" />
            </div>
        </div>
    );
}

export default ChatbotElementComponent;
